import { actions } from '@ecosystem/newron-design-system'
import React, { ReactElement } from 'react'
import * as styles from './index.module.scss'

interface Props {
  title: string
  content: ReactElement | string
  onCloseClick: () => void
}

const PageTitleModal: React.FC<Props> = ({ title, content, onCloseClick }) => {
  const { IconButton } = actions
  const { Close } = IconButton.icons
  return (
    <div className={styles.background}>
      <span className={styles.modalCard}>
        <div className={styles.modalTitle}>
          {title}
          <IconButton onClick={onCloseClick}>
            <Close />
          </IconButton>
        </div>
        <div className={styles.modalContent}>{content}</div>
      </span>
    </div>
  )
}

export default PageTitleModal
